import { render } from "./SystemLog.vue?vue&type=template&id=3acc85e9&scoped=true"
import script from "./SystemLog.vue?vue&type=script&lang=js"
export * from "./SystemLog.vue?vue&type=script&lang=js"

import "./SystemLog.vue?vue&type=style&index=0&id=3acc85e9&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acc85e9"]])

export default __exports__